import { ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalRoot, ModalTitle } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

import * as styles from './styles.css';
import { ETestId } from '../../../common/constants';
import { EFiltersMobileTestId } from '../../types';
import { DateRangeModal } from '../DateRangeModal';
import { Chip, ChipText } from '../RedesignedFilters';

interface IDatesChipContentProps {
  isOpen: boolean;
  label: string | undefined;
  fromValue: Date | undefined;
  toValue: Date | undefined;
  minDate: Date;
  maxDate: Date;
  handleClose: () => void;
  handleClick: () => void;
  handleChange: (from: Date | undefined, to: Date | undefined) => void;
  handleApply: () => void;
  handleReset: () => void;
}

export function DatesChipContent({
  isOpen,
  fromValue,
  toValue,
  minDate,
  maxDate,
  handleClose,
  handleClick,
  handleChange,
  handleApply,
  handleReset,
  label,
}: IDatesChipContentProps) {
  return (
    <ModalRoot open={isOpen} onOpenChange={handleClose}>
      <Chip onClick={handleClick} isSelected={Boolean(label)} testId={ETestId.RedesignedFiltersDatesChip}>
        <ChipText>{label || 'Выберите даты'}</ChipText>
      </Chip>
      <ModalContent>
        <div className={styles['header']}>
          <ModalCloseButton
            title="Закрыть"
            size="XS"
            theme="fill_light"
            icon={<IconActionClose16 />}
            data-testid={EFiltersMobileTestId.DateFilterModalClose}
          />
          <ModalHeader>
            <ModalTitle>Даты поездки</ModalTitle>
          </ModalHeader>
        </div>
        <ModalBody>
          <DateRangeModal
            initialFrom={fromValue}
            initialTo={toValue}
            onChange={handleChange}
            onApply={handleApply}
            onReset={handleReset}
            min={minDate}
            max={maxDate}
          />
        </ModalBody>
      </ModalContent>
    </ModalRoot>
  );
}
